export const heroProduct = () => {
  if (document.querySelector('.hero-product')) {

    window.lenis = lenis;
    console.log(document.querySelector('.hero-product a'))
    document.querySelector('.hero-product a')?.addEventListener('click', (e) => {
      e.preventDefault()
      const scrollAmount = window.innerHeight;
      lenis.scrollTo(scrollAmount, {
        duration: 1,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });
    });
  }


}